import _classCallCheck from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _CurrencySymbol;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * # 用来处理数字/浮点数相关的工具函数
 *
 * 统一使用类型为 `import type { BigNumber } from "BigNumber.js"` 的 BigNumber 来处理数字
 *
 * ## why not `JSBI`, `big.js`, `bn.js`, `decimals.js`, `jsbn` or native `BigInt`?
 *
 * `big.js`, `bignumber.js`, `decimals.js` 可以支持 小数 （浮点数），其他 lib 只能支持 整数。
 * 如果需要支持小数，需要自己操作 { amount: uint256, decimals: uint8 } 的结构，同时要处理除法精度问题，比较麻烦。
 * 这三个 lib 都是同一个作者实现的，三者的区别可以看作者的解释：<https://github.com/MikeMcl/big.js/wiki>
 * `big.js` 有最小的包体积和较完整的 API，但 `bignumber.js` 和 `decimals.js` 对大整数运算更快，并直接支持
 * 带`0x`前导的十六进制字符串。同时 `decimals.js` 在计算时会出现精度丢失的情况。
 *
 * 因为，我们最终选择 `bignumber.js` 作为项目的唯一数字/浮点数库。
 */
import BigNumber from 'bignumber.js';
BigNumber.config({
  ROUNDING_MODE: BigNumber.ROUND_DOWN
});
export var Currency;

(function (Currency) {
  Currency["CNY"] = "CNY";
  Currency["USD"] = "USD";
})(Currency || (Currency = {}));

export var CurrencySymbol = (_CurrencySymbol = {}, _defineProperty(_CurrencySymbol, Currency.CNY, '¥'), _defineProperty(_CurrencySymbol, Currency.USD, '$'), _CurrencySymbol);
export var FixedPointNumberInterface = /*#__PURE__*/function (_BigNumber) {
  _inherits(FixedPointNumberInterface, _BigNumber);

  var _super = _createSuper(FixedPointNumberInterface);

  function FixedPointNumberInterface() {
    var _this;

    _classCallCheck(this, FixedPointNumberInterface);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "amount", void 0);

    _defineProperty(_assertThisInitialized(_this), "decimals", void 0);

    return _this;
  }

  _createClass(FixedPointNumberInterface, [{
    key: "toSignificant",
    value:
    /**
     * 将 BigNumber 对象，转换为指定有效数字的字符串
     *
     * 有效数字指科学计算中用以表示一定长度浮点数精度的那些数字。一般指一个用小数形式表示的浮点数中，
     * 从第一个非零的数字算起的所有数字，因此，1.24和0.00124的有效数字都有3位。并且在取有效数字时
     * 会遵循`四舍五入`的进位规则。
     *
     * @docs: [有效数字](https://zh.wikipedia.org/wiki/%E6%9C%89%E6%95%88%E6%95%B0%E5%AD%97)
     * @returns {string}
     */
    function toSignificant(significantNumber) {
      return this.amount.shiftedBy(-this.decimals).sd(significantNumber).toString();
    }
  }, {
    key: "toDecimalsFixed",
    value: function toDecimalsFixed(fixedAt) {
      var roundedMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BigNumber.ROUND_DOWN;
      return this.amount.shiftedBy(-this.decimals).toFixed(fixedAt, roundedMode);
    }
  }, {
    key: "toAutoFormat",
    value: function toAutoFormat() {
      var significantNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
      var roundedMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BigNumber.ROUND_DOWN;
      var decimalToUnit = new BigNumber(this.toDecimalsFixed(this.decimals, roundedMode));
      if (decimalToUnit.gte(1)) return decimalToUnit.decimalPlaces(4).toFormat();
      return this.toSignificant(significantNumber);
    }
  }, {
    key: "toCurrency",
    value: function toCurrency(currency) {
      var fixedAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var roundingMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BigNumber.ROUND_DOWN;
      var symbol = CurrencySymbol[currency];
      var value = this.toDecimalsFixed(fixedAt, roundingMode);
      return "".concat(symbol).concat(new BigNumber(value).toFormat());
    }
  }]);

  return FixedPointNumberInterface;
}(BigNumber);
export var FixedPointNumber = /*#__PURE__*/function (_FixedPointNumberInte) {
  _inherits(FixedPointNumber, _FixedPointNumberInte);

  var _super2 = _createSuper(FixedPointNumber);

  /**
   * 创建一个 FixedPoint 对象
   *
   * 为什么需要 FixedPoint 对象，而不是直接使用 BigNumber 对象？
   *
   * 1. 保留原始值，方便后续计算。
   * 2. 统一格式化输出
   *
   * @param {BigNumberGens} amount the original number value
   * @param {number} decimals fixed point number of decimals
   */
  function FixedPointNumber(_amount) {
    var _this2;

    var _decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, FixedPointNumber);

    _this2 = _super2.call(this, _amount ? _amount.toString() : '');

    _defineProperty(_assertThisInitialized(_this2), "amount", new BigNumber(0));

    _defineProperty(_assertThisInitialized(_this2), "decimals", 0);

    _this2.amount = _amount ? new BigNumber(_amount.toString()) : new BigNumber(0);

    if (_amount instanceof FixedPointNumber && typeof _decimals === 'undefined') {
      _decimals = _amount.decimals;
    }

    _this2.decimals = Number(_decimals) || 0;
    return _this2;
  }

  _createClass(FixedPointNumber, [{
    key: "toString",
    value: function toString() {
      return this.amount.toString();
    }
  }]);

  return FixedPointNumber;
}(FixedPointNumberInterface);